export default "__VITE_ASSET__CPwsZAEK__"